import { render, staticRenderFns } from "./PatientEvents.vue?vue&type=template&id=979642ec&"
import script from "./PatientEvents.vue?vue&type=script&lang=js&"
export * from "./PatientEvents.vue?vue&type=script&lang=js&"
import style0 from "./PatientEvents.vue?vue&type=style&index=0&id=979642ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports